import { Box } from '../Box/Box';
import { BannerWrapper } from './styles';
import { ReactNode } from 'react';
import CloseBannerIcon from './images/CloseBannerIcon.svg?react';
import { COLORS } from '@/styles/colors';
import { Typography } from '../Typography/Typography';

type BannerType = {
  children: ReactNode;
  icon?: ReactNode;
  background?: string;
  isClosable?: boolean;
  onClose?: () => void;
};

export const Banner = ({ children, icon, background, isClosable, onClose }: BannerType) => {
  return (
    <BannerWrapper background={background}>
      <Box display='flex' justifyContent='center' alignItems='center' columnGap='12px' width='100%'>
        {icon && <>{icon}</>}
        <Typography color={COLORS.black} fontWeight='medium' variant='bodySmall'>
          {children}
        </Typography>
      </Box>
      {isClosable && (
        <Box marginLeft='auto' cursor='pointer'>
          <CloseBannerIcon onClick={onClose} />
        </Box>
      )}
    </BannerWrapper>
  );
};
